import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    DeliveryPage,
    CateringFormatPage,
    CateringEventFormatPage,
    CateringEventPage,
    CulinaryStudioPage,
    PortfolioEventsPage,
    PortfolioEventPage,
    OutdoorBarsPage,
    OutdoorBarArticlePage,
    SweetShopPage,
    SweetShopArticlesPage,
    CulinaryStudioArticlePage,
    DeliveryArticlePage,
    HomePage,
    CateringPage,
    NotFoundPage,
    CartPage,
    PlacesPage,
    PlacePage,
    SweetShopArticlePage,
    LinkPage,
    ReviewPage,
    FeedbackPage,
    CakeToOrderPage,
} from 'pages';

const routes: RouteObject[] = [
    {
        path: '*',
        element: <NotFoundPage />,
    },
    {
        path: '/delivery',
        element: <DeliveryPage />,
        id: 'delivery',
    },
    {
        path: '/catering',
        element: <CateringPage />,
        id: 'catering',
    },
    {
        path: '/catering/formats/:slug',
        element: <CateringFormatPage />,
        id: 'catering_formats',
    },
    {
        path: '/catering/event-format/:slug',
        element: <CateringEventFormatPage />,
        id: 'catering_event-format',
    },
    {
        path: '/catering/events/:slug',
        element: <CateringEventPage />,
        id: 'catering_event',
    },
    {
        path: '/culinary-studio',
        element: <CulinaryStudioPage />,
        id: 'culinary-studio',
    },
    {
        path: '/portfolio-events',
        element: <PortfolioEventsPage />,
        id: 'portfolio-events',
    },
    {
        path: '/portfolio-events/:id',
        element: <PortfolioEventPage />,
        id: 'portfolio-event',
    },
    {
        path: '/outdoor-bars',
        element: <OutdoorBarsPage />,
        id: 'outdoor-bars',
    },
    {
        path: '/outdoor-bars/:id',
        element: <OutdoorBarArticlePage />,
        id: 'outdoor-bar-article',
    },
    {
        path: '/sweet-shop',
        element: <SweetShopPage />,
        id: 'sweet-shop',
    },
    {
        path: '/sweet-shop/articles-to-order/:id',
        element: <CakeToOrderPage />,
        id: 'sweet-shop-cake-to-order',
    },
    {
        path: '/sweet-shop/categories/:id',
        element: <SweetShopArticlesPage />,
        id: 'sweet-shop-articles',
    },
    {
        path: '/culinary-studio/:id',
        element: <CulinaryStudioArticlePage />,
        id: 'culinary-studio-article',
    },
    {
        path: '/delivery/:id',
        element: <DeliveryArticlePage />,
        id: 'delivery-article',
    },
    {
        path: '/',
        element: <HomePage />,
        id: 'home',
    },
    {
        path: '/cart',
        element: <CartPage />,
        id: 'cart',
    },
    {
        path: '/places',
        element: <PlacesPage />,
        id: 'places',
    },
    {
        path: '/places/:id',
        element: <PlacePage />,
        id: 'place',
    },
    {
        path: '/sweet-shop/articles/:id',
        element: <SweetShopArticlePage />,
        id: 'sweet-shop-article',
    },
    {
        path: '/link',
        element: <LinkPage />,
        id: 'link',
    },
    {
        path: '/review',
        element: <ReviewPage />,
        id: 'review',
    },
    {
        path: '/say',
        element: <FeedbackPage />,
        id: 'say',
    },
];

export default routes;
